import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiLock } = FiIcons;

const OutputEditor = ({ value, onChange }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6, delay: 0.4 }}
      className="space-y-3"
    >
      <label className="flex items-center space-x-2 text-sm font-medium text-slate-300">
        <SafeIcon icon={FiLock} className="w-4 h-4 text-green-400" />
        <span>Encrypted output</span>
      </label>
      
      <div className="relative">
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Encrypted JavaScript will appear here..."
          rows={12}
          className="w-full px-4 py-3 bg-slate-800/50 border border-slate-700/50 rounded-xl text-slate-200 placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-green-500/50 focus:border-green-500/50 transition-all duration-200 code-editor scrollbar-thin resize-none"
        />
      </div>
      
      {value && (
        <div className="text-xs text-slate-400">
          {value.split('\n').length} lines, {value.length} characters
        </div>
      )}
    </motion.div>
  );
};

export default OutputEditor;